import { ref } from 'vue'

export const newErrorToast = ref()
export const errorToasts = ref([])
